import { render, staticRenderFns } from "./table-cell.vue?vue&type=template&id=6af31ed2&scoped=true"
import script from "./table-cell.vue?vue&type=script&lang=js"
export * from "./table-cell.vue?vue&type=script&lang=js"
import style0 from "./table-cell.vue?vue&type=style&index=0&id=6af31ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af31ed2",
  null
  
)

export default component.exports